import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { LoginIcon, LogoIcon, LogoIconVariant, LogoutIcon, TingleIcon } from '@repo/ui/icons';
import { getServiceName } from '@repo/utils';

import useCheckMediaQuery from 'hooks/useCheckMediaQuery';

import ExternalLink from 'components/link/ExternalLink';

export interface MainHeaderProps {
  isLogin?: boolean;
  onLogin?: () => void;
  onLogout?: () => void;
}

const MainHeader = ({ isLogin, onLogin, onLogout }: MainHeaderProps) => {
  const theme = useTheme();
  const serviceName = getServiceName();

  const Logo = () => {
    switch (serviceName) {
      case 'tingle':
        return (
          <div className="tingle-logo">
            <TingleIcon.Logo color={theme.color.label.primary} />
          </div>
        );
      default:
        return (
          <div className="bubblechat-logo">
            <LogoIcon variant={LogoIconVariant.REWARD} color={theme.color.icon.icon_4} />
          </div>
        );
    }
  };

  const handleLogin = () => {
    onLogin?.();
  };

  const handleLogout = () => {
    onLogout?.();
  };

  const { isLaptop } = useCheckMediaQuery();

  return (
    <SWrapper>
      <nav>
        <ExternalLink to={import.meta.env.VITE_APP_CHAT_URL}>
          <Logo />
        </ExternalLink>
        {/* <ul></ul> */}
      </nav>
      {isLogin ? (
        <SButton onClick={handleLogout} data-testid="logout">
          <LogoutIcon />
        </SButton>
      ) : (
        <SButton onClick={handleLogin} data-testid="login">
          <LoginIcon />
        </SButton>
      )}
    </SWrapper>
  );
};

export default MainHeader;

const SWrapper = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: space-between;

  nav {
    display: flex;
    align-items: center;
    gap: 40px;

    .bubblechat-logo {
      width: 205px;
      height: 48px;
      display: flex;
      align-items: center;

      i {
        width: 205px;
        height: 36px;
      }
    }

    .tingle-logo {
      width: 216px;
      height: 67px;
      display: flex;
      align-items: center;

      i {
        width: 216px;
        height: 41px;
      }
    }
  }

  @media ${({ theme }) => theme.device.medium} {
    nav {
      .bubblechat-logo {
        width: 160px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          width: 160px;
          height: 28px;
        }
      }

      .tingle-logo {
        width: 124px;
        height: 36px;
        display: flex;
        align-items: center;

        i {
          width: 124px;
          height: 24px;
        }
      }
    }
  }
`;

const SButton = styled.button`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  background: ${({ theme }) => theme.color.buttons.default};
`;
